<template>
    <div>
        <modal
        class="new-modal-default"
        :name="modal_name"
        transition="nice-modal-fade"
        :delay="100"
        :width="650"
        :height="270"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="false"
        style="pointer-events:inherit !important" 
        v-bind:click-to-close="false"
        >
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div></div>
                    <div>
                        <span v-if="disableDelete == false" class="v-modal-dialog-title v-modal-title">Edit Picture</span>
                        <span v-else class="v-modal-dialog-title v-modal-title">Add Picture</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideSelf"></span>
                    </div>
                </div>
                <div class="v-modal-body">
                    <div class="v-modal-layout">
                        <div class="d-flex justify-content-around mt-8 mb-8">
                            <div style="position: relative;">
                                <label class="pointer edit-picture-box pointer mb-0">
                                    <input type="file" ref="myCompanyCoverpic" accept="image/x-png, image/gif, image/jpeg, image/png, image/svg" @change="uploadAttachment" />
                                    <span class="ml-3">
                                        Upload New Picture
                                    </span>
                                </label>
                                <hollow-dots-spinner v-if="disableButtonAndDisplayLoader == true" style="position: absolute;margin: 0;top: 78px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                            </div>
                            <div v-if="disableDelete == false" class="pointer edit-picture-box" @click="deletePic">
                                Delete Picture
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <sweet-modal ref="success_modal" icon="success">Profile uploaded successfully</sweet-modal>
            <sweet-modal ref="delete_modal">Profile Deleted successfully</sweet-modal>
        </modal>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import { SweetModal } from 'sweet-modal-vue';
import axios from "axios";
import { HollowDotsSpinner } from "epic-spinners";
import { EventBus } from '../eventBus/nav-bar-event';
export default {
    props: ["modal_name"],
    components:{
        Swal,
        SweetModal,
        HollowDotsSpinner,
    },
    data(){
        return{
            disableDelete: false,
            disableButtonAndDisplayLoader: false,
            // success_msg:'',
        }
    },
    methods: {
        hideSelf() {
            this.$modal.hide(this.modal_name);
        },
        uploadAttachment(e) {
            this.disableButtonAndDisplayLoader = true;
            var input = e.target;
            if (input.files && input.files[0]) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                name: input.files[0].name,
                size: JSON.stringify(input.files[0].size),
                source: source,
                progress: 0,
                created_time: new Date(),
                error: "",
                };
                this.getResumableURL(input.files[0], attachment);
            }
        },
        getResumableURL(file, attachment) {
            let vuethis = this;
            let data = {
                file: attachment.name,
            };
            data = new FormData();
            data.append("file", file);
            this.$http.post("https://cloudapis.digicollect.com/external/upload_file", data).then(response => {
                this.$refs.success_modal.open();;
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.hideSelf();
                    this.disableButtonAndDisplayLoader = false;
                    this.$emit("uploaded", response.data.url)
                }, 2000);
            }).catch(error => {
                this.disableButtonAndDisplayLoader = false;
            });
        },
        deletePic() {
            try {
                Swal.fire({
                    title: 'Alert',
                    text: "Are you sure want to delete ?",
                    type: 'warning',
                    icon: 'warning',
                    showCloseButton: true,
                    showCancelButton: true,
                    cancelButtonText:'NO',
                    confirmButtonText:'YES',
                    confirmButtonColor:'#00448b'
                }).then((result) => {
                    if (result.value) {
                        this.$refs.success_modal.open();;
                        setTimeout(() => {
                            this.$refs.success_modal.close();
                            this.hideSelf();
                            this.$emit("deletePic");
                        }, 2000);
                    }
                })
            } catch (reason) {
                // console.log(reason)
            }
        }
    },
    mounted(){
        EventBus.$on("profile_picture", (profile_picture)=>{
            // console.log(profile_picture)
            if(profile_picture.endsWith("No Picture.svg")){
                this.disableDelete = true;
            } else {
                this.disableDelete = false;
            }
        })
    },
}
</script>

<style scoped>
    .edit-picture-box {
        text-transform: none !important;
        border: 2px dashed #6a6a6a;
        height: 7em;
        width: 18em;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #6a6a6a;
        font-size: 15px;
    }
    @media only screen and (max-width: 599px){
        .edit-picture-box{
            width: 12em !important;
            font-size: 12px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/alertModals/EditPicture.vue